export default "__VITE_ASSET__DEDxkp2R__"